import { useCallback, useEffect, useState } from 'react'

import abiPTOV2 from 'abi/abi-pto-v2.json'
import { useContractViem } from 'hooks/contract/use-contract-viem'
import { logError } from 'utils/logger'

/**
 * PTO v2 - read the minted NFT count (totalSupply) from the collection contract.
 */
export const useCollectionTotalSupply = (collectionAddress?: string | null) => {
  const contract = useContractViem((collectionAddress as any) || null, abiPTOV2)

  const [totalSupply, setTotalSupply] = useState(0)

  const getTotalSupply = useCallback(async () => {
    try {
      if (!contract) {
        setTotalSupply(0)
        return
      }
      const res = await contract.read.totalSupply()
      setTotalSupply(Number(res || 0))
    } catch (error) {
      setTotalSupply(0)
      logError('error get collection totalSupply-----------------', error)
    }
  }, [contract])

  useEffect(() => {
    getTotalSupply()
  }, [getTotalSupply])

  return {
    totalSupply,
    getTotalSupply,
  }
}
